import React, { useEffect, useState } from "react";
/* import { ConnectButton } from '@rainbow-me/rainbowkit';
import { WalletComponent } from './WalletComponent'; */

export default function UserNetwork() {
    const [block, setBlock] = useState("");
    const [showGuest, setShowGuest] = useState(true);
    const [showAccount, setShowAccount] = useState(false);
    const [showNetwork, setShowNetwork] = useState(false);

    const handleShow = () => {
        setShowAccount(!showAccount);
        setShowGuest(!showGuest);
        setShowNetwork(false);
    };

    const getNetworkColor = (network) => {
        const colors = {
            arbitrum: ["bg-[#213147]", "ARB"],
            optimism: ["bg-[#FF0420]", "OP"],
            polygon: ["bg-[#6a00f5]", "POL"],
            binance: ["bg-[#f3bc30]", "BSC"],
            solana: ["bg-[#1f1f1f]", "SOL"],
            base: ["bg-[#0051ff]", "BASE"],
        }
        return colors[network] || ["bg-black", "Null"]
    };

    const getNetworkSvg = (network) => {
        const colors = {
            solana: (<svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08398 5.22265C7.17671 5.08355 7.33282 5 7.5 5H18.5C18.6844 5 18.8538 5.10149 18.9408 5.26407C19.0278 5.42665 19.0183 5.62392 18.916 5.77735L16.916 8.77735C16.8233 8.91645 16.6672 9 16.5 9H5.5C5.3156 9 5.14617 8.89851 5.05916 8.73593C4.97215 8.57335 4.98169 8.37608 5.08398 8.22265L7.08398 5.22265ZM7.76759 6L6.43426 8H16.2324L17.5657 6H7.76759Z" fill="#ffffff" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08398 15.2226C7.17671 15.0836 7.33282 15 7.5 15H18.5C18.6844 15 18.8538 15.1015 18.9408 15.2641C19.0278 15.4267 19.0183 15.6239 18.916 15.7774L16.916 18.7774C16.8233 18.9164 16.6672 19 16.5 19H5.5C5.3156 19 5.14617 18.8985 5.05916 18.7359C4.97215 18.5734 4.98169 18.3761 5.08398 18.2226L7.08398 15.2226ZM7.76759 16L6.43426 18H16.2324L17.5657 16H7.76759Z" fill="#ffffff" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.08398 13.7774C7.17671 13.9164 7.33282 14 7.5 14H18.5C18.6844 14 18.8538 13.8985 18.9408 13.7359C19.0278 13.5733 19.0183 13.3761 18.916 13.2226L16.916 10.2226C16.8233 10.0836 16.6672 10 16.5 10H5.5C5.3156 10 5.14617 10.1015 5.05916 10.2641C4.97215 10.4267 4.98169 10.6239 5.08398 10.7774L7.08398 13.7774ZM7.76759 13L6.43426 11H16.2324L17.5657 13H7.76759Z" fill="#ffffff" />
            </svg>),
            optimism: (<svg width="30px" height="30px" viewBox="0 0 28 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4695 14.6399C14.3165 14.6399 14.2145 14.589 14.1635 14.4869C14.0615 14.3849 14.0615 14.2829 14.0615 14.1299L16.7135 1.53295C16.7645 1.37995 16.8155 1.27795 16.9175 1.17595C17.0195 1.07395 17.1725 1.02295 17.2745 1.02295H22.4255C23.1905 1.02295 23.9045 1.12495 24.5675 1.27795C25.2305 1.48195 25.7405 1.73695 26.1995 2.09395C26.6075 2.45095 26.9135 2.96095 27.0665 3.52195C27.2195 4.08295 27.2195 4.74595 27.0665 5.45995C26.7605 6.93895 26.0975 8.06095 25.0775 8.77495C24.1085 9.48895 22.7825 9.84595 21.0995 9.84595H18.4985L17.6315 14.0789C17.5805 14.2319 17.5295 14.3339 17.4275 14.4359C17.3255 14.5379 17.2235 14.589 17.0705 14.589H14.4695V14.6399ZM19.0595 7.24495H21.3035C21.8135 7.24495 22.3235 7.09195 22.7315 6.83695C23.1395 6.53095 23.4455 6.12295 23.5475 5.56195C23.5985 5.20495 23.6495 4.94995 23.5985 4.69495C23.5475 4.43995 23.4455 4.23595 23.1905 4.08295C22.9865 3.92995 22.6295 3.82795 22.1705 3.82795H19.8245L19.0595 7.24495Z" fill="white" />
                <path d="M6.15647 14.8439C5.34047 14.8439 4.57548 14.7419 3.91248 14.5379C3.19848 14.3339 2.63748 13.9769 2.12748 13.5689C1.66848 13.1099 1.31148 12.5999 1.10748 11.9369C0.903476 11.2739 0.903476 10.5089 1.00548 9.6419C1.10748 9.0809 1.20948 8.5199 1.31148 7.9589C1.46448 7.3979 1.56648 6.8369 1.71948 6.2759C2.12748 4.5419 2.89248 3.2159 4.01448 2.2979C5.13648 1.3799 6.61548 0.920898 8.50248 0.920898C9.31848 0.920898 10.0835 1.0229 10.7465 1.2779C11.4605 1.4819 12.0215 1.8389 12.5315 2.2979C13.0415 2.7569 13.3475 3.3179 13.5515 3.9809C13.7555 4.6439 13.8065 5.4089 13.6535 6.2759C13.5515 6.8369 13.4495 7.3979 13.3475 7.9589C13.2455 8.4689 13.0925 9.0299 12.9905 9.5399C12.5315 11.3249 11.7665 12.6509 10.6445 13.5179C9.52248 14.3849 8.04347 14.8439 6.15647 14.8439ZM6.41147 12.0389C7.12547 12.0389 7.73748 11.8349 8.24748 11.4269C8.75748 11.0189 9.16548 10.3559 9.36948 9.4379C9.52248 8.8769 9.62447 8.3159 9.72647 7.8059C9.82847 7.2959 9.93048 6.7859 10.0325 6.2249C10.1855 5.3069 10.1345 4.6439 9.77748 4.2359C9.47148 3.8279 8.96148 3.6239 8.24748 3.6239C7.53348 3.6239 6.92147 3.8279 6.41147 4.2359C5.90147 4.6439 5.54448 5.3069 5.28948 6.2249C5.13648 6.7859 5.03447 7.2959 4.88147 7.8059C4.77947 8.3159 4.67748 8.8259 4.57548 9.4379C4.42248 10.3559 4.47348 11.0189 4.83048 11.4269C5.18748 11.8349 5.69747 12.0389 6.41147 12.0389Z" fill="white" />
            </svg>),
            base: (<svg width="30px" height="30px" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_354_1442)"><path d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z" fill="white" /><path d="M10.5462 17.7966C14.6159 17.7966 17.9149 14.5032 17.9149 10.4406C17.9149 6.37808 14.6159 3.08472 10.5462 3.08472C6.68517 3.08472 3.51771 6.0491 3.20312 9.82232H12.9429V11.059H3.20312C3.51771 14.8322 6.68517 17.7966 10.5462 17.7966Z" fill="#0052FF" /></g><defs><clipPath id="clip0_354_1442"><rect width="21" height="21" fill="white" /></clipPath></defs></svg>),
            arbitrum: (<svg width="30px" height="30px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 2500 2500"
                fill="none"
            >
                <rect width="2500" height="2500" fill="none" />
                <path
                    fill="#213147"
                    d="M226,760v980c0,63,33,120,88,152l849,490c54,31,121,31,175,0l849-490c54-31,88-89,88-152V760
      c0-63-33-120-88-152l-849-490c-54-31-121-31-175,0L314,608c-54,31-87,89-87,152H226z"
                />
                <path
                    fill="#12AAFF"
                    d="M1435,1440l-121,332c-3,9-3,19,0,29l208,571l241-139l-289-793C1467,1422,1442,1422,1435,1440z"
                />
                <path
                    fill="#12AAFF"
                    d="M1678,882c-7-18-32-18-39,0l-121,332c-3,9-3,19,0,29l341,935l241-139L1678,883V882z"
                />
                <path
                    fill="#9DCCED"
                    d="M1250,155c6,0,12,2,17,5l918,530c11,6,17,18,17,30v1060c0,12-7,24-17,30l-918,530c-5,3-11,5-17,5
      s-12-2-17-5l-918-530c-11-6-17-18-17-30V719c0-12,7-24,17-30l918-530c5-3,11-5,17-5l0,0V155z M1250,0c-33,0-65,8-95,25L237,555
      c-59,34-95,96-95,164v1060c0,68,36,130,95,164l918,530c29,17,62,25,95,25s65-8,95-25l918-530c59-34,95-96,95-164V719
      c0-68-36-130-95-164L1344,25c-29-17-62-25-95-25l0,0H1250z"
                />
                <polygon
                    fill="#213147"
                    points="642,2179 727,1947 897,2088 738,2234"
                />
                <path
                    fill="#FFFFFF"
                    d="M1172,644H939c-17,0-33,11-39,27L401,2039l241,139l550-1507c5-14-5-28-19-28L1172,644z"
                />
                <path
                    fill="#FFFFFF"
                    d="M1580,644h-233c-17,0-33,11-39,27L738,2233l241,139l620-1701c5-14-5-28-19-28V644z"
                />
            </svg>),
            polygon: (<svg width="30px" height="30px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 178 161"
                fill="none"
            >
                <path
                    fill="#FFFFFF"
                    d="M66.8,54.7l-16.7-9.7L0,74.1v58l50.1,29l50.1-29V41.9L128,25.8l27.8,16.1v32.2L128,90.2l-16.7-9.7v25.8  
         l16.7,9.7l50.1-29V29L128,0L77.9,29v90.2l-27.8,16.1l-27.8-16.1V86.9l27.8-16.1l16.7,9.7V54.7z"
                />
            </svg>),
            binance: (<svg width="30px" height="30px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg"><path fill="#FFFFFF" d="m16.624 13.92 2.717 2.716-7.353 7.353-7.352-7.352 2.717-2.717 4.636 4.66 4.635-4.66zm4.637-4.636L24 12l-2.715 2.716L18.568 12l2.693-2.716zm-9.272 0 2.716 2.692-2.717 2.717L9.272 12l2.716-2.715zm-9.273 0L5.41 12l-2.692 2.692L0 12l2.716-2.716zM11.99.01l7.352 7.33-2.717 2.715-4.636-4.636-4.635 4.66-2.717-2.716L11.989.011z" /></svg>),
        }
        return colors[network] || (<i className="fas fa-gem text-white text-lg"></i>)
    };

    useEffect(() => {
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", (e) => {
                const span = e.target.nextElementSibling;
                if (e.target.checked) {
                    span.classList.add("bg-purple-600");
                    span.classList.remove("bg-gray-300");
                    span.firstElementChild.classList.add("translate-x-5");
                    span.firstElementChild.classList.remove("translate-x-0");
                } else {
                    span.classList.remove("bg-purple-600");
                    span.classList.add("bg-gray-300");
                    span.firstElementChild.classList.remove("translate-x-5");
                    span.firstElementChild.classList.add("translate-x-0");
                }
            });
        });
    }, [showGuest, showAccount, showNetwork]);

    return (
        <div className="absolute top-0 right-0 flex flex-wrap justify-center gap-6 p-4 pt-[7rem] z-[1]">
            {showGuest && <section className="h-full bg-white rounded-xl border border-solid border-gray-300 shadow-md w-60 flex flex-col justify-between">
                <div>
                    <div className="flex justify-between items-center border-b border-gray-200 border-solid px-4 py-3">
                        <p className="text-sm font-normal text-black">Guest User</p>
                        <button className="bg-pink-500 text-white text-xs font-semibold rounded-md px-3 py-1" type="button">
                            VERIFY
                        </button>
                    </div>
                    <nav className="flex flex-col gap-3 px-4 py-3 text-sm font-normal text-gray-400">
                        <p>More</p>
                    </nav>
                    <nav className="flex flex-col gap-3 px-4 text-sm font-normal text-black mb-4">
                        <a href="#" className="flex justify-between items-center">
                            Moodeng Credit <i className="fas fa-chevron-right"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            Privacy policy <i className="fas fa-chevron-right"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            Terms and conditions <i className="fas fa-chevron-right"></i>
                        </a>
                    </nav>
                </div>
                {/* <ConnectButton />
                <WalletComponent /> */}
                <button onClick={() => handleShow()} className="bg-blue-600 text-white font-bold text-sm rounded-b-xl w-full py-3" type="button">
                    SIGN IN
                </button>
            </section>}

            {showAccount && <section className="h-full bg-white rounded-xl border border-solid border-gray-300 shadow-md w-72 flex flex-col justify-between">
                <div>
                    <div className="flex justify-between items-center border-b border-gray-200 border-solid px-4 py-3">
                        <p className="text-sm font-normal text-black">Account Name</p>
                        <button
                            className="bg-purple-600 text-white text-xs font-semibold rounded-md px-3 py-1 flex items-center gap-1"
                            type="button">
                            <i className="fas fa-coins"></i> IOU 50000
                        </button>
                    </div>
                    {!showNetwork && <div className="flex border-b border-gray-200 border-solid">
                        <div onClick={() => setShowNetwork(!showNetwork)} className="flex items-center gap-2 w-2/3 px-4 py-3 text-sm font-normal">
                            Network
                            <i className="fas fa-exchange-alt"></i>
                        </div>
                        <div className={`${getNetworkColor(block)[0]} w-1/3 text-white font-extrabold text-sm flex items-center justify-center gap-[5px]`}>
                            {getNetworkSvg(block)}
                            {getNetworkColor(block)[1]}
                        </div>
                    </div>}
                    {showNetwork && <section className="w-full h-full bg-white rounded-xl shadow-md w-60 flex flex-col justify-between">
                        <div>
                            <div onClick={() => setShowNetwork(!showNetwork)} className="flex border-b border-gray-200 border-solid">
                                <div className="flex gap-2 w-2/3 px-4 py-3 text-sm font-normal">
                                    Change Network
                                </div>
                                <div className={`${getNetworkColor(block)[0]} w-1/3 text-white font-extrabold text-sm flex items-center justify-center gap-[5px]`}>
                                    {getNetworkSvg(block)}
                                    {getNetworkColor(block)[1]}
                                </div>
                            </div>
                            <nav onClick={() => setShowNetwork(!showNetwork)} className="flex flex-col gap-3 px-4 py-3 text-sm font-normal text-black">
                                <a onClick={() => setBlock("binance")} href="#" className="flex justify-start items-center gap-3">
                                    <div className="w-8 h-8 rounded-sm bg-[#f3bc30] flex items-center justify-center">{getNetworkSvg("binance")}</div> Binance
                                    <i className="fas fa-chevron-right ml-auto"></i>
                                </a>
                                <a onClick={() => setBlock("optimism")} href="#" className="flex justify-start items-center gap-3">
                                    <div className="w-8 h-8 rounded-sm bg-[#FF0420] flex items-center justify-center">{getNetworkSvg("optimism")}</div> Optimism
                                    <i className="fas fa-chevron-right ml-auto"></i>
                                </a>
                                <a onClick={() => setBlock("polygon")} href="#" className="flex justify-start items-center gap-3">
                                    <div className="w-8 h-8 rounded-sm bg-[#6a00f5] flex items-center justify-center">{getNetworkSvg("polygon")}</div> Polygon
                                    <i className="fas fa-chevron-right ml-auto"></i>
                                </a>
                                <a onClick={() => setBlock("base")} href="#" className="flex justify-start items-center gap-3">
                                    <div className="w-8 h-8 rounded-sm bg-[#0051ff] flex items-center justify-center">{getNetworkSvg("base")}</div> Base
                                    <i className="fas fa-chevron-right ml-auto"></i>
                                </a>
                                <a onClick={() => setBlock("arbitrum")} href="#" className="flex justify-start items-center gap-3">
                                    <div className="w-8 h-8 rounded-sm bg-[#213147] flex items-center justify-center">{getNetworkSvg("arbitrum")}</div> Arbitrum
                                    <i className="fas fa-chevron-right ml-auto"></i>
                                </a>
                                <a onClick={() => setBlock("solana")} href="#" className="flex justify-start items-center gap-3">
                                    <div className="w-8 h-8 rounded-sm bg-[#1f1f1f] flex items-center justify-center">{getNetworkSvg("solana")}</div> Solana
                                    <i className="fas fa-chevron-right ml-auto"></i>
                                </a>
                            </nav>
                        </div>
                    </section>}
                    <div className="px-4 py-3 text-xs font-normal text-gray-400">Account Settings</div>
                    <nav className="flex flex-col gap-3 px-4 text-sm font-normal text-black">
                        <a href="#" className="flex justify-between items-center">
                            Profile <i className="fas fa-chevron-right"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            Repay Loans <i className="fas fa-chevron-right"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            Connect Account <i className="fas fa-plus"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            View Loan History <i className="fas fa-chevron-right"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            View Lending History <i className="fas fa-chevron-right"></i>
                        </a>
                    </nav>
                    <div className="border-t border-gray-200 border-solid mt-4 px-4 py-3 flex flex-col gap-3 text-sm font-normal text-black">
                        <label className="flex justify-between items-center cursor-pointer">
                            Push notifications
                            <input aria-label="Push notifications toggle" className="toggle toggle-primary hidden"
                                type="checkbox" />
                            <span
                                className="w-11 h-6 bg-gray-300 rounded-full relative inline-block transition-colors duration-300">
                                <span
                                    className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow transform transition-transform duration-300">
                                </span>
                            </span>
                        </label>
                        <label className="flex justify-between items-center cursor-pointer">
                            Dark mode
                            <input aria-label="Dark mode toggle" className="toggle toggle-primary hidden" type="checkbox" />
                            <span
                                className="w-11 h-6 bg-gray-300 rounded-full relative inline-block transition-colors duration-300">
                                <span
                                    className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow transform transition-transform duration-300">
                                </span>
                            </span>
                        </label>
                    </div>
                    <div className="border-t border-gray-200 border-solid px-4 py-3 text-xs font-normal text-gray-400">
                        Information
                    </div>
                    <nav className="flex flex-col gap-3 px-4 text-sm font-normal text-black mb-4">
                        <a href="#" className="flex justify-between items-center">
                            Increase Credit Limit <i className="fas fa-chevron-right"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            What are IOU Points? <i className="fas fa-chevron-right"></i>
                        </a>
                        <a href="#" className="flex justify-between items-center">
                            How to get verified? <i className="fas fa-chevron-right"></i>
                        </a>
                    </nav>
                </div>
                <button
                    onClick={() => handleShow()}
                    className="bg-pink-500 text-white font-bold text-sm rounded-b-xl w-full py-3 flex justify-center items-center gap-2"
                    type="button">
                    SIGN OUT <i className="fas fa-sign-out-alt"></i>
                </button>
            </section>}
        </div>
    );
}
